export const initialState = () => ({
  questionsList: [],
  savedQuestionsUuid: []
})
